export function getAppConfigRouteData(route = useRoute()) {
  const { experienceBaseRoute, singleConfigBaseRoute } = useApplicationConstants()
  const identifier = route.params?.identifier ?? ''
  const moduleIdentifier = route.params?.moduleIdentifier ?? ''
  const entrypointIdentifier = (route.params?.entrypointIdentifier || route.params?.identifier) ?? ''
  const internalRouteCore = entrypointIdentifier ? `/${singleConfigBaseRoute}/${entrypointIdentifier}` : `/${experienceBaseRoute}`

  return {
    identifier,
    moduleIdentifier,
    entrypointIdentifier,
    internalRouteCore
  }
}
